import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AnswersProvider from './store/AnswersContext/AnswersContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AnswersProvider>
      <App />
    </AnswersProvider>
  </React.StrictMode>
);
